import React from 'react';
import OrderDesign from './OrderDesign';
import OrderSidebarOrderList from './components/OrderSidebarOrderList';
import './components/OrderSidebarStyleCard.css';
import { useTranslation } from 'react-i18next';
import { playSoundEffect } from './hooks/useSoundEffects';
import './StrategyModal.css';

function CompletedOrdersModal({ show, onClose, completedOrders, gameState, userId = null, hoveredOrder, onHoverOrder, essiaLuhrActive = false, onEssiaLuhrSelect = null }) {
  const { t } = useTranslation();

  if (!show || !completedOrders) return null;

  const hoveredOrderData = hoveredOrder !== null && completedOrders.length > 0
    ? completedOrders.find((o, idx) => (o.instanceId || o.id || idx) === hoveredOrder)
    : null;

  return (
    <div 
      className="modal-overlay"
      style={{
        position: 'absolute',
        top: '-100%',
        left: '-100%',
        width: '300%',
        height: '300%',
        background: 'rgba(0,0,0,0.7)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      {/* Expanded OrderDesign shown to the right of the modal */}
      {hoveredOrderData && (
        <div
          style={{
            position: 'absolute',
            left: 'calc(50% + 300px)',
            top: '50%',
            transform: 'translateY(-50%)',
            marginLeft: '20px',
            zIndex: 3000,
            pointerEvents: 'none'
          }}
        >
          <OrderDesign
            order={hoveredOrderData}
            count={0}
            minimal={false}
            lazyLoad={true}
            gameState={gameState}
            userId={userId}
          />
        </div>
      )}
      <div 
        style={{
          background: '#121212',
          padding: '24px',
          borderRadius: '12px',
          minWidth: '400px',
          maxWidth: '600px',
          maxHeight: '864px', // 80% of 1080px base height
          overflowY: 'auto',
          overflowX: 'visible',
          boxShadow: '0 0 24px #000',
          position: 'relative'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '20px',
          borderBottom: '1px solid #333',
          paddingBottom: '10px'
        }}>
          <h3 style={{ color: 'white', margin: 0 }}>
            {t('battleUI.completedOrders') || 'Completed Orders'}
          </h3>
          <button
            onClick={() => {
              playSoundEffect('/sounds/click.mp3');
              onClose();
            }}
            style={{
              background: '#333',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '8px 16px',
              cursor: 'pointer',
              fontSize: '1em',
              transition: 'background 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.background = '#444'}
            onMouseLeave={(e) => e.target.style.background = '#333'}
          >
            {t('battleUI.close') || 'Close'}
          </button>
        </div>
        
        <div style={{ marginBottom: '10px', color: '#aaa', fontSize: '0.9em' }}>
          {t('battleUI.totalCompletedOrders') || 'Total'}: {completedOrders.length || 0}
        </div>

        <div className="strategy-modal-list">
          {completedOrders && completedOrders.length > 0 ? (
            <OrderSidebarOrderList
              items={completedOrders.filter((order) => !essiaLuhrActive || order.type === 'Strategem')}
              getGroupKey={(order) => `${order.id}|${order.type || 'unknown'}`}
              getDisplayName={(order) => order.name || 'Unknown Order'}
              getDisplayCost={(order) => order.cost ?? 'N/A'}
              costLabel={t('strategy.cost')}
              renderRowWrapperClassName={(order, group) => {
                const hoverKey = order.instanceId || order.id || group.firstIndex;
                const isHovered = hoveredOrder === hoverKey;
                const isStrategem = order.type === 'Strategem';
                const showGetButton = essiaLuhrActive && isStrategem && isHovered && onEssiaLuhrSelect;
                const essiaHighlight = essiaLuhrActive && isStrategem;
                return `${essiaHighlight ? 'strategy-modal-order-entry--essia' : ''}${
                  showGetButton ? ' strategy-modal-order-entry--with-actions' : ''
                }`.trim();
              }}
              onItemMouseEnter={(order, group) => {
                playSoundEffect('/sounds/hoverover.mp3', 0.3);
                onHoverOrder(order.instanceId || order.id || group.firstIndex);
              }}
              onItemMouseLeave={() => onHoverOrder(null)}
              renderAfterCard={(order, group) => {
                const hoverKey = order.instanceId || order.id || group.firstIndex;
                const isHovered = hoveredOrder === hoverKey;
                const isStrategem = order.type === 'Strategem';
                const showGetButton = essiaLuhrActive && isStrategem && isHovered && onEssiaLuhrSelect;
                if (!showGetButton) return null;
                return (
                  <button
                    type="button"
                    className="strategy-modal-get-btn strategy-modal-get-btn--affordable"
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => {
                      e.stopPropagation();
                      onEssiaLuhrSelect(order.instanceId || order.id, order.id);
                    }}
                  >
                    {t('battleUI.get') || 'Get'}
                  </button>
                );
              }}
              resolveOrderRecord={(order) => order}
            />
          ) : (
            <div style={{ color: '#aaa', textAlign: 'center', padding: '20px' }}>
              {essiaLuhrActive
                ? (t('battleUI.noStrategemsInCompletedOrders') || 'No strategems in completed orders')
                : (t('battleUI.noCompletedOrders') || 'No completed orders yet')}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CompletedOrdersModal;

